import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import { DefaultBackground, DefaultFontStyle } from '../../styles/global-styles'

export const Background = styled.div`
  ${DefaultBackground};
  z-index: 11;
  display: none;

  &.show {
    display: block;
  }
`

export const NavMenu = styled.nav`
  display: flex;
  flex-direction: row;
  padding-top: 0px;
  gap: 40px;
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    flex-direction: column;
    gap: 5px;
    padding-top: 24px;
  }
`

const MenuItemStyle = `
  ${DefaultFontStyle};
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  user-select: none;
  align-self: start;
`

export const MenuItem = styled.span`
  ${MenuItemStyle};
  cursor: default;
  text-decoration: underline;
  text-underline-offset: 16px;
  text-decoration-color: #d82036;
  text-decoration-thickness: 4px;
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    text-decoration: none;
  }
`

export const MenuItemLink = styled(NavLink)`
  ${MenuItemStyle};
  text-decoration: none;
  color: ${props => props.theme.colours.black};
  &:hover,
  &:focus,
  &:active {
    cursor: pointer;
  }
`
export const NavBarWrapperContainer = styled.div`
  position: fixed;
  z-index: 11;
  height: 100%;
  width: 290px;
  background-color: rgba(255, 255, 255, 0.97);
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  border-radius: 10px;
  padding: 20px;
  right: -291px;
  transition: 500ms;
  &.show {
    right: 0;
  }
`

export const NavBarWrapperFlexbox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const UserName = styled.div`
  ${DefaultFontStyle};
  font-weight: 600;
  font-size: 24px;
  padding-top: 20px;
  width: 1ch;
`
export const MenuIcon = styled.img`
  width: 43px;
  height: 43px;
  &.hidden {
    visibility: hidden;
  }
`

export const ButtonContainer = styled.div`
  padding-top: 30px;
`
